@if (pdfSource) {
  <div class="flex flex-col gap-3 h-full">
    <div class="flex justify-between">
      @if (isPage) {
        <div style="display: flex; gap: 10px; align-items: center">
          <button matButton="filled" (click)="page = page - 1" [disabled]="page === 1">
            Anterior
          </button>
          <span>Página {{ page }}</span>
          <button matButton="filled" (click)="page = page + 1">Siguiente</button>

          <span style="border-left: 1px solid #ccc; height: 20px; margin: 0 10px"></span>

          <button matIconButton (click)="zoom = zoom - 0.1">
            <mat-icon>remove</mat-icon>
          </button>
          <span>Zoom: {{ (zoom * 100).toFixed(0) }}%</span>
          <button matIconButton (click)="zoom = zoom + 0.1">
            <mat-icon>add</mat-icon>
          </button>

          <button matIconButton (click)="isPage = !isPage">
            <mat-icon><span class="material-symbols-outlined"> insert_page_break </span></mat-icon>
          </button>
          <span style="border-left: 1px solid #ccc; height: 20px; margin: 0 10px"></span>
        </div>
      } @else {
        <button matIconButton (click)="isPage = !isPage">
          <mat-icon><span class="material-symbols-outlined"> two_pager </span></mat-icon>
        </button>
      }

      <div class="flex flex-row gap-3">
        <button (click)="getPdf()" class="button-general-light" matButton="filled">
          <mat-icon class="text-white!">save</mat-icon>
          Guardar Archivo
        </button>
        @if (data && data.quotationId) {
          <button (click)="closeModal()" class="button-general-light" matButton="filled">
            <mat-icon class="text-white!">close</mat-icon>
            Cerrar
          </button>
        }
      </div>
    </div>

    @if (isPage) {
      <pdf-viewer
        [src]="pdfSource"
        [(page)]="page"
        [zoom]="zoom"
        [render-text]="true"
        [original-size]="false"
        [fit-to-page]="true"
        [show-all]="false"
        style="display: block; width: auto; height: 85vh; border: 1px solid #ddd"
        (after-load-complete)="afterLoadComplete($event)"
      ></pdf-viewer>
    } @else {
      <pdf-viewer
        [src]="pdfSource"
        [rotation]="0"
        [original-size]="false"
        [show-all]="true"
        [fit-to-page]="false"
        [zoom]="1"
        [zoom-scale]="'page-width'"
        [stick-to-page]="false"
        [render-text]="true"
        [external-link-target]="'blank'"
        [autoresize]="true"
        [show-borders]="false"
        style="display: block; width: auto; height: 85vh; border: 1px solid #ddd"
        (after-load-complete)="afterLoadComplete($event)"
      ></pdf-viewer>
    }
  </div>
}
<app-load-general [load]="isLoading"></app-load-general>
